<template>
    <div class="p-grid p-fluid">
        <div class="p-col-12">

            <Rotulo cols="12 4">
                <Button label="Ver Ciclos" class="botao" @click="irPara()" />
            </Rotulo>

        </div>
        <Panel :header='"Criar Ciclo (Campos Obrigatorios)"' class="p-col-12" v-if="camposCiclo">
            <div class="p-grid p-fluid">
                <Rotulo nome="Exercício" cols="12 3">
                    <Dropdown v-model="anoExercicioSelecionado" placeholder="Selecione um exercício"
                        :options="camposExercicios" optionLabel="ano"
                        v-if="(this.contador == 0 || this.contador == 1)" />
                </Rotulo>
                <Rotulo nome="Nome do ciclo" cols="12 3">
                    <InputText v-model="ciclo.nomeCiclo"
                        :disabled="camposCiclo.statusCiclo == 'ABERTO' || camposCiclo.statusCiclo == 'INATIVO'" />
                </Rotulo>
                <Rotulo nome="Termo" cols="12 3">
                    <Dropdown v-model="termoSelecionado" placeholder="Selecione o termo" :options="termos"
                        optionLabel="descTermo" />
                </Rotulo>
                <Rotulo nome="Questionario" cols="12 3">
                    <Dropdown v-model="questionarioSelecionado" placeholder="Selecione o questionario"
                        :options="questionarios" optionLabel="descQuestionario" dataKey="idenQuestionario" />
                </Rotulo>
                <Rotulo nome="Data de início" cols="12 3">
                    <InputMask mask="99/99/9999 99:99:99" v-model="ciclo.dataInicial"
                        placeholder="__/__/____ __:__:__" />
                </Rotulo>
                <Rotulo nome="Data e hora final" cols="12 3">
                        <InputMask mask="99/99/9999 99:99:99" v-model="ciclo.dataFinal"
                            placeholder="__/__/____ __:__:__" />
                </Rotulo>
                <Rotulo nome="Status ciclo" v-if="ciclo.status != null" cols="12 3">
                    <InputText v-model="ciclo.status" :disabled="true" />
                </Rotulo>
                <Rotulo nome="Tipo de ciclo" cols="12 3">
                    <Dropdown :options="tipoCiclo" optionLabel="tipoCicloName" optionValue="tipoCicloName"
                        placeholder="Desabilitado" v-model="ciclo.tipoCiclo" :disabled=true
                        v-if="(this.contador == 0 || this.contador == 1)" />
                    <Dropdown :options="tipoCiclo" optionLabel="tipoCicloName" optionValue="tipoCicloName"
                        placeholder="Desabilitado" v-model="ciclo.tipoCiclo" :disabled=true v-else />
                </Rotulo>
            </div>
        </Panel>
        <Panel header="Definição de público alvo" class="p-col-12">
            <Rotulo nome="Selecionar público alvo" cols="12">
                <DataTable :value="publicoAlvo" :selection.sync="vinculosSelecionados">
                    <Column headerStyle="width: 3em">
                        <template #body="slotProps">
                            <Checkbox v-if="ciclo.status == 'ABERTO'" :id="slotProps.data.idenTipoVinculo"
                                :value="slotProps.data" v-model="vinculosSelecionados"
                                :disabled="ciclo.status == 'ABERTO'" />
                            <Checkbox v-else :id="slotProps.data.idenTipoVinculo" :value="slotProps.data"
                                v-model="vinculosSelecionados" />
                        </template>
                    </Column>
                    <Column header="Tipos de vínculo" field="descTipoVinculo"></Column>
                </DataTable>
            </Rotulo>
        </Panel>
        <Rotulo cols="12 8" />

        <Rotulo cols="12 4"
            v-if="(camposCiclo.statusCiclo != 'ABERTO' && termoSelecionado != null && 
            questionarioSelecionado != null && ciclo.nomeCiclo != null && ciclo.dataInicial != null && 
            ciclo.dataFinal != null && vinculosSelecionados.length > 0)">
            <Button :label="dados ? 'Editar Ciclo' : 'Criar Ciclo'" icon="pi pi-check" class="p-button-success"
                @click="criarCiclo()" />
        </Rotulo>
    </div>

</template>
<script>
import { mapState } from 'vuex'
import Rotulo from '@/template/RotuloSeplag.vue'
import { baseApiUrl } from '@/config/global'
import { printToast } from '../../config/global'
import moment from 'moment'

const getDefaultCiclo = () => {
    return {
        nomeCiclo: null,
        dataInicial: null,
        dataFinal: null,
        exercicio: null,
        status: null,
        tipoCiclo: null
    }
}

export default {
    name: "gerenciaCiclo",
    components: { Rotulo },
    data: function () {
        return {
            ciclo: getDefaultCiclo(),
            formatDate: "DD/MM/YYYY HH:mm:ss",
            camposCiclo: [],
            vinculosPreenchidos: [],
            vinculosSelecionados: [],
            camposExercicios: [],
            anoExercicioSelecionado: null,
            publicoAlvo: [],
            tipoCiclo: [],
            anoExercicio: [],
            auxCriaCiclo: [],
            contador: 0,
            cicloProrrogado: [],
            nomeCicloProrrogado: null,
            cicloExtemporaneo: [],
            nomeCicloExtemporaneo: null,
            auxCarregaCiclo: [],
            termoSelecionado: null,
            termos: [],
            questionarioSelecionado: null,
            questionarios: [],
            nomeCicloParaCriar: null
        }
    },
    methods: {
        async carregarDados() {
            try {
                const res = await this.$http.get(`${baseApiUrl}/gerenciaciclo/base`);
                const { exercicios, tipoVinculos, tipoCiloEnum, termos, questionarios } = res.data;

                // Atualiza as propriedades do componente
                this.camposExercicios = exercicios.filter(e => e.statExercicio === "ATIVO");
                this.publicoAlvo = tipoVinculos;
                this.tipoCiclo = tipoCiloEnum.map(value => ({ tipoCicloName: value }));
                this.termos = termos;
                this.questionarios = questionarios;
            } catch (error) {
                console.error("Erro ao carregar dados:", error);
            }
        },
        async criarCiclo() {
            let criarCicloOuEditar = {
                "exercicio": {
                    "idenExercicio": this.anoExercicioSelecionado.idenExercicio
                },
                "termo": {
                    "idenTermo": this.termoSelecionado.idenTermo
                },
                "questionario": {
                    "idenQuestionario": this.questionarioSelecionado.idenQuestionario
                },
                "dataInicio": this.ciclo.dataInicial,
                "dataFinal": this.ciclo.dataFinal,
                "descCiclo": this.ciclo.nomeCiclo,
                "tipoVinculo": this.vinculosSelecionados
            }

            if (!this.dados) { //Cria um novo Ciclo
                let response = await this.$http.post(`${baseApiUrl}/ciclos`, JSON.stringify(criarCicloOuEditar))
                if (response.status == 201) {
                    printToast({ severity: 'success', summary: 'Ação efetuada!', detail: `Ciclo: ${this.ciclo.nomeCiclo} criado com sucesso`, life: 3000 })
                } else {
                    printToast({ severity: 'error', summary: 'Ação não foi efetuada!', detail: `Erro ao criar ciclo ${this.ciclo.nomeCiclo}`, life: 3000 })
                }
            } else { //Edita um Existente 
                let response = await this.$http.put(`${baseApiUrl}/ciclos/${this.dados.idenCiclo}`, JSON.stringify(criarCicloOuEditar))
                if (response.status == 200) {
                    printToast({ severity: 'success', summary: 'Ação efetuada!', detail: `Ciclo: ${this.ciclo.nomeCiclo} alterado com sucesso`, life: 3000 })
                } else {
                    printToast({ severity: 'error', summary: 'Ação não foi efetuada!', detail: `Erro ao alterar ciclo ${this.ciclo.nomeCiclo}`, life: 3000 })
                }
            }
        },
        async dadosParaEditar() {
            if (this.dados) {
                const res = await this.$http.get(`${baseApiUrl}/ciclos/${this.dados.idenCiclo}`);
                this.anoExercicioSelecionado = res.data.exercicio,
                    this.termoSelecionado = res.data.termo,
                    this.ciclo.nomeCiclo = res.data.descCiclo,
                    this.questionarioSelecionado = res.data.questionario,
                    this.ciclo.dataInicial =res.data.dataInicio,
                    this.ciclo.dataFinal = res.data.dataFinal,
                    this.vinculosSelecionados = res.data.tipoVinculo
            }
        },
        limpaCampos() {
            this.camposCiclo = [null]
            this.ciclo = getDefaultCiclo()
            this.contador = 0
            this.vinculosSelecionados = []
        },
        irPara() {
            this.$router.push('/' + process.env.VUE_APP_BASE_URL + '/ciclo')
        }
    },
    computed: {
        ...mapState(['getCicloEditarDados']),
        dados() {
            return this.$store.getters.getCicloEditarDados;
        }

    },
    mounted() {
        this.carregarDados()
        this.dadosParaEditar()
        window.scrollTo(0, -1000)
    }

}
</script>
<style scoped>
.botoesSuperiores {
    display: flex;
    justify-content: space-around;
}

.buscaCiclo {
    display: flex;
    justify-content: space-between;
}

.ciclo {
    display: flex;
}

.classeButton {
    margin-top: 20px;
}
</style>